// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"468":"a10c8966","707":"d056c16d"}[chunkId] + ".chunk.css";
};